/**
 * Schema of ResponsavelUsuario
 * @author Thacryba
 */
import {bool, date, InputType, Schema} from 'simpli-web-sdk'
import ResponsavelUsuario from '@/model/resource/ResponsavelUsuario'
import RenderResponsavelAction from '@/components/render/responsavel/RenderResponsavelAction.vue'
import RenderLabelValue from '@/components/render/RenderLabelValue.vue'

export default (model: ResponsavelUsuario): Schema => ({
  actions: {
    content: {
      component: RenderResponsavelAction,
      props: {
        model,
      },
    },
    textContent: null,
  },

  responsavel: {
    hidden: true,
    input: InputType.SELECT,
  },

  idResponsavelUsuarioPk: {
    content: {
      component: RenderLabelValue,
      props: {
        value: model.idResponsavelUsuarioPk,
        tagClass: 'default',
      },
    },
    editable: false,
  },

  codigoAcesso: {
    content: model.codigoAcesso,
    input: InputType.TEXT,
    meta: {
      maxlength: '255',
    },
  },

  nome: {
    content: model.nome,
    input: InputType.TEXT,
    meta: {
      required: true,
      maxlength: '255',
    },
  },

  email: {
    content: model.email,
    input: InputType.EMAIL,
    meta: {
      required: true,
    },
  },

  dataGeracaoCodigoAcesso: {
    content: date(model.dataGeracaoCodigoAcesso),
    input: InputType.DATE,
    meta: {
      required: true,
    },
  },

  ehSenhaTemporaria: {
    content: bool(model.ehSenhaTemporaria),
    input: InputType.CHECKBOX,
  },

  permitirCadastrarUsuario: {
    content: bool(model.permitirCadastrarUsuario),
    input: InputType.CHECKBOX,
  },

  ativo: {
    content: bool(model.ativo),
    input: InputType.CHECKBOX,
  },

  senha: {
    content: model.senha,
    input: InputType.PASSWORD,
  },

  tipoResponsavelUsuario: {
    content: model.tipoRespUsuario && model.tipoRespUsuario.$tag || '',
  },

  filial: {
      content: model.responsavel && model.responsavel.nomeFantasia || '',
  },
})
